import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export type EmptyCollectionContent = {
  placeholderImages: string[];
  title: string;
  message: string;
};

export function EmptyCollection({
  placeholderImages,
  title,
  message,
  children,
}: React.PropsWithChildren<EmptyCollectionContent>) {
  return (
    <div>
      <div className="row">
        <div className="col-xs-12 image-carousel">
          {placeholderImages.map((el, idx) => {
            return <LazyLoadImage key={idx} src={el} alt="Login" className="img-fluid" />;
          })}
        </div>
      </div>
      <h2 className="text-center mt-4 mb-3"> {title} </h2>
      <p className="text-center">{message}</p>
      {children}
    </div>
  );
}
